import { Component, Input, SimpleChanges } from '@angular/core';
import { Notification, NotificationRequest } from '@modules/notification/interface/notification.interface';
import { NotificationService } from '@modules/notification/service/notification.service';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { NotificationCardComponent } from './components/notification-card/notification-card.component';
import { NotificationsSkeletonComponent } from './components/notifications-skeleton/notifications-skeleton.component';


@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [
    ButtonModule,
    PaginatorModule,
    FormsModule,
    DropdownModule,
    NotificationCardComponent,
    NotificationsSkeletonComponent,
  ],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent {

  notificationsResponse: NotificationRequest = {} as NotificationRequest;
  notificationsList!: Notification[] | null;
  first!: number;
  rows!: number;
  totalRecords!: number ;
  options = [
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
    { label: 100, value: 100 }
  ];
  @Input() selectedContext!: String;
  @Input() selectedNotificationOption!: String;
  @Input() isAllNotificationsVisible!: boolean;
  @Input() newNotifications?: Notification[];

  constructor(
    private notificationService : NotificationService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if((changes['selectedNotificationOption'] || changes['selectedContext']) && this.isAllNotificationsVisible) {
      this.getAllNotifications(this.selectedNotificationOption,1, 10, this.selectedContext);
    }
  }

  getAllNotifications(status:String =  'all', page:Number = 1, limit:Number = 10, context:String = 'all'): void {
    this.notificationsList = null;
    this.notificationService.getAllNotifications(status, page, limit, context).subscribe({
      next: (data)=>{
        this.notificationsResponse = data;
        this.notificationsList = data.docs;
        this.totalRecords = data.totalDocs;
        this.first = data.pagingCounter-1;
        this.rows = data.limit;
      },
      error: (err)=>{
        console.log("err", err);
      }
    })
  }

  onPageChange(event: PaginatorState) {
    this.first = event.first || 0;
    this.rows = event.rows || 10;

    this.getAllNotifications(this.selectedNotificationOption,((this.first+1)/this.rows)+1 || 1, event.rows, this.selectedContext);
  }

  onLimitChange() {
    this.getAllNotifications(this.selectedNotificationOption ,1, this.rows, this.selectedContext);
  }

  handleShowAllNotifications() {
    this.isAllNotificationsVisible = !this.isAllNotificationsVisible;
  }

}
